<template>
    <!-- <div class="bar py-3" > -->
    <div class="bar py-3" v-if="$GVO.ats.calling>0">
		<div class="mx-auto">
			<center>
				<div>	
					<el-popover
						placement="bottom"
						title=""
						width="300"
						trigger="click"
						style="height: 386px;"
						>
							<button class="btn btn-success bl" style="padding-top: 13px;padding-bottom: 13px;" slot="reference">
								<!-- <i class="tim-icons icon-tap-02"></i> -->
								<div class="tonal-icon "></div>
							</button>
						
							<div class="tonal" >
								<div class="mb-0">
									<div class="btnclicked"> <p class="tonal-number">{{btnclicked}}</p> </div>
									<div class="tonal-grid">
										<button class="tonal-item" @click="sendDTMF(1)"><p class="tonal-number">1</p></button>
										<button class="tonal-item" @click="sendDTMF(2)"><p class="tonal-number">2</p></button>
										<button class="tonal-item" @click="sendDTMF(3)"><p class="tonal-number">3</p></button>
										<button class="tonal-item" @click="sendDTMF(4)"><p class="tonal-number">4</p></button>
										<button class="tonal-item" @click="sendDTMF(5)"><p class="tonal-number">5</p></button>
										<button class="tonal-item" @click="sendDTMF(6)"><p class="tonal-number">6</p></button>
										<button class="tonal-item" @click="sendDTMF(7)"><p class="tonal-number">7</p></button>
										<button class="tonal-item" @click="sendDTMF(8)"><p class="tonal-number">8</p></button>
										<button class="tonal-item" @click="sendDTMF(9)"><p class="tonal-number">9</p></button>
										<button class="tonal-item" @click="sendDTMF('*')"><p class="tonal-number" style="margin-top: 5px;">*</p></button>
										<button class="tonal-item" @click="sendDTMF(0)"><p class="tonal-number">0</p></button>
										<button class="tonal-item" @click="sendDTMF('#')"><p class="tonal-number">#</p></button>
									</div>
								</div>
							</div>
						
					</el-popover>

					<!-- <button class="btn btn-success bl" disabled style="display:none"> -->
					<button class="btn btn-success bl" v-if="$GVO.ats.calling>0" disabled style="display:none">
						<i class="tim-ic ic-phone"></i>
					</button>
						
					<div class="call-number d-inline mx-4" v-if="phone!=''">{{ phone }}</div>
					
					<button class="btn btn-danger" @click="hangup()" v-if="$GVO.ats.calling>0">
					<!-- <button class="btn btn-danger" @click="hangup()" > -->
						<i class="tim-ic ic-phone"></i>
					</button>
				</div>
			</center>
		</div>
    </div>
</template>


<script>
	import { Popover, Button } from 'element-ui';
	export default {
	    name: 'RePhoneBar',
		components: {
			[Popover.name]: Popover,
		},
		props: {
			counter: String,
		},
	    data () {
			return {
				show:false,
				phone:'',
				call: null,
				ver: 1,
				timer:0,
				btnclicked: '',
			}
	    },
	    computed: {
			CallTimer:function(){
				if(this.$GVO.ats.calling<2){
					this.timer=0;
				}else{
					if(this.timer==0){
						this.timer=parseInt(new Date().getTime()/1000)
					}
					return parseInt(new Date().getTime()/1000)-this.timer;
				}
				return '';
			},
	    },
		watch:{
		},
	    methods: {
			hangup(){
				this.$GVO.ats.end();
			},
			sendDTMF(val){
				// console.log('send', val);
				this.$GVO.ats.sendDTMF(val);
				this.btnclicked += val + ' ';
			}
	    },
	    mounted(){
			this.$GVO.PhoneBar=this;
	    },
	}
</script>
<style scoped>
    .bar {
		display:block;
		position:fixed;
		top:0px;
		left:0px;
		z-index:1051;
		min-height:60px;
		width:100%;
		background-color:#1d253b;
		border-bottom:  1px solid #01B0E0;
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
    }
	.bar i { font-size: 18px;}
    
    .bl{
         -webkit-animation: blink 2s linear infinite;
          animation: blink 2s linear infinite;
	}
	.call-number {
		font-size:26px; 
		color:#FFF; 
		position: relative; top:5px;
		
	}
	.tonal-icon {
		/* www/public/img/tonal_1.svg */
		display: block;
		background-image: url('/img/tonal_2.svg');
		
		background-repeat: no-repeat;
		width:16px;
		height: 16px;
		margin-top: 2px;
	}
	.tonal {
		width: 100%;
		max-width: 300px;
		height: 427px;
		/* height: 360px; */
		padding: 10px;
	}
	.tonal-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: minmax(67px, auto);
		/* grid-template-columns: 100px 50px 100px; */
		/* grid-template-rows: 80px auto 80px;  */
		column-gap: 26px;
		row-gap: 26px;
	}
	.tonal-item {
		border:1px solid transparent;
		/* border: 1px dotted #01b0e0; */
		border-radius: 50px;
		width: 100%;
		height: 100%;
		place-self: center;
	}
	.tonal-item:hover {
		cursor: pointer;
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.6) !important;
		border: 1px solid rgba(1, 176, 224, 0.6);
	}
	.tonal-item:hover .tonal-number {color: #01b0e0; }

	.tonal-number {
		height: 100%;
		font-size: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #000;
	}
	.tonal button:focus { outline: 2px solid rgba(1, 176, 224, 0.6); }
	.tonal button:focus .tonal-number {color: #01b0e0; }
	/* .tonal button:focus .tonal-item:hover {border:1px solid transparent;} */
	/* .bar >>> .el-popover {
		background: inherit!important;
		border: 1px solid transparent!important;
		
	} */
    .btnclicked {
		height: 67px;
	}

	@media (max-width: 400px) {
		.btn {padding: 11px 27px;}
		.call-number {font-size:22px; margin: 8px!important;}
	}
                                                  
</style>
